
<template>
  <div class="day-plan-container">
    <div>
      <div class="day-plan-header">
        <div class="info-field">
          <van-field
            readonly
            clickable
            name="calendar"
            :value="planDay"
            placeholder="点击选择日期"
            @click="showCalendar = true"
          >
            <template #right-icon>
              <img class="icon-calendar" src="@/assets/imgs/calendar.png" alt />
            </template>
          </van-field>
          <van-calendar
            v-model="showCalendar"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="onCalendarConfirm"
            :show-confirm="false"
            poppable
            get-container="body"
          />
          <van-field
            readonly
            clickable
            name="picker"
            :value="seller.salesUnitName"
            placeholder="选择销售公司"
            @click="showPicker = true"
          >
            <template #right-icon>
              <img
                class="icon-select-arrow"
                src="@/assets/imgs/select-arrow.png"
                alt
              />
            </template>
          </van-field>
        </div>
        <div class="info-line">
          <span class="info-label">销售公司：</span>
          <span class="info-value">{{ seller.salesUnitName }}</span>
        </div>
        <div class="info-line">
          <span class="info-label">计划日期：</span>
          <span class="info-value">{{ planDay }} 08:00 至次日 08:00</span>
        </div>
      </div>
      <div class="card-wrap">
        <div
          class="day-plan-card"
          v-for="(item, index) in terminalList"
          :key="item.terminalCode"
        >
          <van-collapse v-model="activeStation">
            <van-collapse-item :name="item.terminalCode">
              <template #title>
                <div class="collapse-title">
                  <p v-if="item.status == '10'" class="tag">待提交</p>
                  <p v-if="item.status == '20'" class="tag">待审核</p>
                  <p v-if="item.status == '30'" class="tag">审核中</p>
                  <p v-if="item.status == '40'" class="tag">已审核</p>
                  <p v-if="item.status == '50'" class="tag">变更审核中</p>
                  <p v-if="item.status == '60'" class="tag">变更已通过</p>
                  <p v-if="item.status == '70'" class="tag">变更已关闭</p>
                  接收站/液化厂：{{ item.terminalName }}
                </div>
              </template>
              <div class="content" v-if="curTab == 'add'">
                <!-- 先隐藏 -->
                <div class="content-line">
                  <div class="content-line-label">单价:</div>
                  <div class="content-line-value">
                    {{ item.price == null?0:item.price }}元/吨
                  </div>
                </div>
                <div class="content-line">
                  <div class="content-line-label">原始需求量（吨）:</div>
                  <div class="content-line-value">
                    <van-field
                      class="content-line-field"
                      v-model="item.originalWeight"
                      type="number"
                      @click="handleEditClick(item, index)"
                    ></van-field>
                  </div>
                </div>
                <div class="content-line">
                  <div class="content-line-label">审批通知:</div>
                  <div class="content-line-value">
                    <van-field
                      class="content-line-field"
                      v-model="item.telephones"
                      @click="handleEditClick(item, index)"
                    ></van-field>
                  </div>
                </div>
              </div>
              <!-- v-if="curTab == 'detail'" -->
              <div class="content" v-else>
                <!-- 先隐藏 -->
                <div class="content-line">
                  <div class="content-line-label">单价:</div>
                  <div class="content-line-value">
                    {{ item.price == null?0:item.price }}元/吨
                  </div>
                </div>
                <div class="content-line">
                  <div class="content-line-label">原始需求量（吨）:</div>
                  <div class="content-line-value">
                    {{ item.originalWeight | emptyFilter }}
                    <div
                      v-if="
                        item.status == '20' ||
                        (item.status == '40' && item.canChange == '1') || 
                        (item.status == '60' && item.canChange == '1') || 
                        (item.status == '70' && item.canChange == '1')
                      "
                      @click="handleEditClick(item, index)"
                    >
                      <img
                        class="icon-edit"
                        src="@/assets/imgs/edit.png"
                        alt="编辑"
                      />
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    item.status == '50' ||
                    item.status == '60' ||
                    item.status == '70'
                  "
                  class="content-line"
                >
                  <div class="content-line-label">变更需求量（吨）:</div>
                  <div class="content-line-value">
                    {{ item.changeWeight | emptyFilter }}
                  </div>
                </div>
                <div class="content-line">
                  <div class="content-line-label">批准需求量（吨）:</div>
                  <div class="content-line-value">
                    {{ item.confirmWeight | emptyFilter }}
                  </div>
                </div>
                <div class="content-line">
                  <div class="content-line-label">审批通知 :</div>
                  <div class="content-line-value">
                    {{ item.telephones | emptyFilter }}
                    <div
                      v-if="item.status == '20'"
                      @click="handleEditClick(item, index)"
                    >
                      <img
                        class="icon-edit"
                        src="@/assets/imgs/edit.png"
                        alt="编辑"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
    </div>

    <van-popup v-model="showEdit" round get-container="body">
      <!-- <EditDialog
        :inTerminal="selectTerminal"
        @saveDayPlan="savePlan"
        @submitDayPlan="queryConstomerBalance"
      ></EditDialog> -->
      <EditDialog
        :inTerminal="selectTerminal"
        @saveDayPlan="savePlan"
        @submitDayPlan="submitPlan"
      ></EditDialog>
    </van-popup>
    <van-popup v-model="showPicker" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        title="销售公司"
        :columns="sellerList"
        value-key="salesUnitName"
        @confirm="onSellerConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import goodsApi from "@/request/goodsApi";
import lngApi from "@/request/lngApi";
import EditDialog from "./EditDialog";
export default {
  name: "LngDayPlanTabContent",
  components: {
    EditDialog,
  },
  props: {
    curTab: String,
  },
  data() {
    return {
      showEdit: false,
      showCalendar: false,
      showPicker: false,
      planDay: "",
      minDate: new Date(),
      maxDate: new Date(),
      seller: {},
      sellerList: [],
      materialCode: "",
      commodityId: "",
      commodityName: "",
      activeStation: [],
      terminalList: [],
      selectTerminal: {},
      selectIndex: "",
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  watch: {
    // curTab: function (tab) {
    //   // alert(tab);
    //   console.log(tab);
    //   this.initPage();
    // },
    curTab: function(val) {
      console.log("Current tab is "+val)
      let curDate = new Date();//当前日期
      let tomorrow = new Date(curDate.getTime()+24*60*60*1000);
      console.log(tomorrow);
      if(this.curTab == 'add'){
        this.minDate = tomorrow;
        this.maxDate.setDate(this.minDate.getDate() + 6);
        this.planDay = this.$utils.formatDate(this.minDate);
      }
      if(this.curTab == 'detail'){
        let year = curDate.getFullYear();
        this.minDate = new Date(new Date().setFullYear(year-1));
        this.maxDate.setDate(tomorrow.getDate() + 6);
        this.planDay = this.$utils.formatDate(curDate);
      }
      if(this.curTab == 'modify'){
        this.minDate = curDate;
        this.maxDate.setDate(tomorrow.getDate() + 6);
        this.planDay = this.$utils.formatDate(this.minDate);
      }
      if(this.curTab == 'modifyDetail'){
        this.minDate = curDate;
        this.maxDate.setDate(tomorrow.getDate() + 6);
        this.planDay = this.$utils.formatDate(this.minDate);
      }
    },
    seller: {
      handler(val) {
        if (val) {
          switch (this.curTab) {
            case "add":
              this.listDayPlan(); //日计划列表，包含（未填报，待提交）
              break;
            case "detail":
              this.viewDayPlanList(); //日计划查看列表
              break;
            case "modify":
              this.applyChangeDayPlanList();
              break;
            case "modifyDetail":
              this.viewChangeDayPlanList();
              break;
          }
        }
      },
      deep: true,
    },
    planDay: function (val) {
      if (val) {
        switch (this.curTab) {
          case "add":
            this.listDayPlan(); //日计划列表，包含（未填报，待提交）
            break;
          case "detail":
            this.viewDayPlanList(); //日计划查看列表
            break;
          case "modify":
            this.applyChangeDayPlanList();
            break;
          case "modifyDetail":
            this.viewChangeDayPlanList();
            break;
        }
      }
    },
  },
  created() {
    this.initPlanDay();
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      this.activeStation = [];
      this.getCommodityId();
      this.getSellerList();
    },
    initPlanDay() {
      let curDate = new Date();
      curDate.setDate(curDate.getDate() + 1);
      this.planDay = this.$utils.formatDate(curDate);
      this.minDate = curDate;
      this.maxDate.setDate(this.minDate.getDate() + 6);
    },
    savePlan(item) {
      this.selectTerminal = item;
      if (this.selectTerminal.planId) {
        this.editDayPlan();
      } else {
        this.saveDayPlan();
      }
    },
    //新增保存日计划
    async saveDayPlan() {
      let params = Object.assign({}, this.selectTerminal);
      params.planDay = this.planDay;
      params.sellerCode = this.seller.salesUnitCode;
      params.sellerName = this.seller.salesUnitName;
      params.materialCode = this.materialCode; //物料编码
      params.commodityId = this.commodityId; //商品ID
      params.commodityName = this.commodityName; //产品名称
      params.crmSeller = this.seller.crmSeller;
      params.a13Seller = this.seller.a13Seller;
      params.dataFrom = 1;
      // console.log(JSON.stringify(params));
      let data = await lngApi.submitDayPlan(params);
      if (data.returnCode == "0") {
        this.showEdit = false;
        // this.$set(this.terminalList, this.selectIndex, this.selectTerminal);
        this.listDayPlan();
        this.$dialog
          .alert({
            message: "保存成功",
            confirmButtonText: "确定",
          })
          .then(() => {});
      } else {
        this.$toast({
          type: "fail",
          message: data.returnMessage,
          duration: 1500,
        });
      }
    },
    //编辑保存日计划
    async editDayPlan() {
      let params = Object.assign({}, this.selectTerminal);
      params.planDay = this.planDay;
      params.dataFrom = 1;
      // console.log(JSON.stringify(params));
      let data = await lngApi.editDayPlan(params);
      if (data.returnCode == "0") {
        this.showEdit = false;
        // this.$set(this.terminalList, this.selectIndex, this.selectTerminal);
        this.listDayPlan();
        this.$dialog
          .alert({
            message: "保存成功",
            confirmButtonText: "确定",
          })
          .then(() => {});
      } else {
        this.$toast({
          type: "fail",
          message: data.returnMessage,
          duration: 1500,
        });
      }
    },
      async submitPlan() {
      //1.获取日均量
      let res = await this.getDayAverager();
      if (res.returnCode == "0") {
        this.selectTerminal.avgDayWeight = res.result.avgDayWeight;
        if (this.selectTerminal.planId) {
          if (
            this.selectTerminal.status == "40" ||
            this.selectTerminal.status == "50" || 
            this.selectTerminal.status == "60" || 
            this.selectTerminal.status == "70"
          ) {
            this.changeDayPlan(); //变更日需求
          } else {
            this.editSubmitDayPlan(); //编辑提报日计划
          }
        } else {
          this.submitDayPlan(); //提报日计划
        }
      } else {
        this.$toast({
          type: "fail",
          message: res.returnMessage,
          duration: 1500,
        });
      }
    },
    //提报日计划
    async submitDayPlan() {
      let params = Object.assign({}, this.selectTerminal);
      params.planDay = this.planDay;
      params.sellerCode = this.seller.salesUnitCode;
      params.sellerName = this.seller.salesUnitName;
      params.materialCode = this.materialCode; //物料编码
      params.commodityId = this.commodityId; //商品ID
      params.commodityName = this.commodityName; //产品名称
      params.crmSeller = this.seller.crmSeller;
      params.a13Seller = this.seller.a13Seller;
      params.dataFrom = 1;
      console.log(JSON.stringify(params));
      let data = await lngApi.saveDayPlan(params);
      if (data.returnCode == "0") {
        this.showEdit = false;
        // this.$set(this.terminalList, this.selectIndex, this.selectTerminal);
        this.listDayPlan();
        this.$dialog
          .alert({
            message: "提报成功",
            confirmButtonText: "确定",
          })
          .then(() => {});
      } else {
        this.$toast({
          type: "fail",
          message: data.returnMessage,
          duration: 1500,
        });
      }
    },
    //编辑提报日计划
    async editSubmitDayPlan() {
      let params = Object.assign({}, this.selectTerminal);
      params.planDay = this.planDay;
      params.dataFrom = 1;
      // console.log(JSON.stringify(params));
      let data = await lngApi.editSubmitDayPlan(params);
      if (data.returnCode == "0") {
        this.showEdit = false;
        // this.$set(this.terminalList, this.selectIndex, this.selectTerminal);
        if (this.curTab == "add") {
          this.listDayPlan();
        }
        if (this.curTab == "detail") {
          this.viewDayPlanList();
        }
        this.$dialog
          .alert({
            message: "提报成功",
            confirmButtonText: "确定",
          })
          .then(() => {});
      } else {
        this.$toast({
          type: "fail",
          message: data.returnMessage,
          duration: 1500,
        });
      }
    },
    async changeDayPlan() {
      let params = {};
      console.log(this.selectTerminal);
      params.planId = this.selectTerminal.planId;
      params.changeTank = this.selectTerminal.originalTank;
      params.changeWeight = this.selectTerminal.originalWeight;
      params.changeVolume = this.selectTerminal.originalVolume;
      params.planDay = this.selectTerminal.planDay;
      let data = await lngApi.changeDayPlan(params);
      if (data.returnCode == "0") {
        this.showEdit = false;
        if (this.curTab == "add") {
          this.listDayPlan();
        }
        if (this.curTab == "detail") {
          this.viewDayPlanList();
        }
        this.$dialog
          .alert({
            message: "变更成功",
            confirmButtonText: "确定",
          })
          .then(() => {});
      } else {
        this.$toast({
          type: "fail",
          message: data.returnMessage,
          duration: 1500,
        });
      }
    },
    //获取日均量
    async getDayAverager() {
      let params = {};
      params.planDay = this.planDay;
      params.memberCode = this.userInfo.companyAuthModel.companyMdm;
      params.sellerCode = this.seller.salesUnitCode;
      params.commodityId = this.commodityId;
      params.terminalCode = this.selectTerminal.terminalCode;
      return await lngApi.getDayAverager(params);
    },
    //余额校验
    async queryConstomerBalance(terminal) {
      this.selectTerminal = terminal;
      let params = {};
      params.planDay = this.planDay;
      params.memberCode = this.userInfo.companyAuthModel.companyMdm;
      params.sellerCode = this.seller.salesUnitCode;
      params.originalVolume = this.selectTerminal.originalVolume;
      params.price = this.selectTerminal.price;
      params.originalWeight = this.selectTerminal.originalWeight;
      let balanceRes = await lngApi.queryConstomerBalance(params);
      if (balanceRes.returnCode == "0") {
        if (balanceRes.status == "0") {
          //CRM查询余额失败
          this.$toast({
            type: "fail",
            message: balanceRes.result.failureReason,
            duration: 1500,
          });
        } else {
          if (balanceRes.result.vaildResult == "0") {
            //余额不足
            this.$dialog
              .alert({
                title: "余额不足",
                message:
                  "你的预付的货款余额不足以支付提报的日计划量，请尽快线下打款，以免耽误装车安排！",
                confirmButtonText: "确定",
              })
              .then(() => {
                this.submitPlan();
              });
          }
        }
      } else {
        this.$toast({
          type: "fail",
          message: balanceRes.returnMessage,
          duration: 1500,
        });
      }
    },
    async getCommodityId() {
      let params = {};
      params.materialCode = this.$common.interfacePath.LngMaterialCode;
      let data = await goodsApi.getList(params);
      if (data.returnCode == "0") {
        this.materialCode = data.result.dataList[0].materialCode;
        this.commodityId = data.result.dataList[0].id;
        this.commodityName = data.result.dataList[0].commodityName;
      } else {
        this.$toast({
          type: "fail",
          message: data.returnMessage,
          duration: 1500,
        });
      }
    },
    async getSellerList() {
      let params = {};
      let res = await lngApi.listSeller(params);
      if (res.returnCode == "0") {
        this.sellerList = res.result;
        if (res.result.length > 0) {
          this.seller = res.result[0];
        }
      } else {
        this.$toast({
          type: "fail",
          message: res.returnMessage,
          duration: 1500,
        });
      }
    },
    onCalendarConfirm(date) {
      this.planDay = this.$utils.formatDate(date);
      this.showCalendar = false;
      // this.listDayPlan();
    },
    onSellerConfirm(value) {
      if(value){
        this.seller = value;
      }
      this.showPicker = false;
    },
    handleEditClick(item, index) {
      // if (item.price == null || item.price == "" || item.price == undefined) {
      //   this.$toast('价格未定，暂时不能提报日指定！');
      //   return false;
      // }
      this.selectTerminal = item;
      this.selectIndex = index;
      this.showEdit = true;
    },
    //日计划列表
    listDayPlan() {
      let params = {};
      params.planDay = this.planDay;
      params.sellerCode = this.seller.salesUnitCode;
      params.sellerName = this.seller.salesUnitName;
      // console.log(JSON.stringify(params));
      lngApi
        .listDayPlan(params)
        .then((res) => {
          if (res.returnCode == "0") {
            this.terminalList = res.result;
          } else {
            this.$toast({
              type: "fail",
              message: res.returnMessage,
              duration: 1500,
            });
          }
        })
        .catch((res) => {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        });
    },
    //日计划查看列表
    viewDayPlanList() {
      let params = {};
      params.planDay = this.planDay;
      params.sellerCode = this.seller.salesUnitCode;
      params.sellerName = this.seller.salesUnitName;
      // console.log(JSON.stringify(params));
      lngApi
        .viewDayPlanList(params)
        .then((res) => {
          if (res.returnCode == "0") {
            this.terminalList = res.result;
          } else {
            this.$toast({
              type: "fail",
              message: res.returnMessage,
              duration: 1500,
            });
          }
        })
        .catch((res) => {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        });
    },
    //变更申请列表
    applyChangeDayPlanList() {
      let params = {};
      params.planDay = this.planDay;
      params.sellerCode = this.seller.salesUnitCode;
      params.sellerName = this.seller.salesUnitName;
      // console.log(JSON.stringify(params));
      lngApi.applyChangeDayPlanList(params).then((res) => {
        if (res.returnCode == "0") {
          this.terminalList = res.result;
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    //变更查看列表
    viewChangeDayPlanList() {
      let params = {};
      params.planDay = this.planDay;
      params.sellerCode = this.seller.salesUnitCode;
      params.sellerName = this.seller.salesUnitName;
      // console.log(JSON.stringify(params));
      lngApi
        .viewChangeDayPlanList(params)
        .then((res) => {
          if (res.returnCode == "0") {
            this.terminalList = res.result;
          } else {
            this.$toast({
              type: "fail",
              message: res.returnMessage,
              duration: 1500,
            });
          }
        })
        .catch((res) => {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl';

.day-plan-header >>> .van-cell {
  height: 64px;
  width: 342px;
  line-height: 63px;
  font-size: 28px;
  border: 1PX solid rgba(102, 102, 102, 1);
  border-radius: 10px;
  align-items: center;
}

.day-plan-header {
  background: $bgColor;
  padding: 24px 24px;

  .info-field {
    display: flex;
    justify-content: space-between;
    padding-bottom: 24px;
  }

  .info-line {
    font-size: 26px;
    line-height: 37px;
    padding: 8px 0;

    .info-label {
      color: #393939;
    }

    .info-value {
      color: #666666;
      margin-left: 16px;
    }

    .info-status {
      position: absolute;
      right: 24px;
      display: inline-block;
      width: 102px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      font-size: 30px;
      color: rgba(225, 32, 32, 1);
      border: 1PX solid rgba(225, 32, 32, 1);
      border-radius: 4px;
    }
  }
}

.icon-calendar {
  width: 42px;
  height: 37.26px;
}

.icon-select-arrow {
  width: 20px;
  height: 10px;
}

.day-plan-card >>> .van-cell {
  height: 90px;
  padding: 24px 0;
  font-size: 30px;
  align-items: center;
}

.day-plan-card >>> .van-cell__title {
  display: flex;
}

.day-plan-card >>>.van-collapse-item__content {
  padding: 24px 0;
  font-size: 26px;
  line-height: 90px;
}

.day-plan-card >>> .van-cell__right-icon {
  font-size: 26px;
  color: #323233;
}

.day-plan-container {
  // flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // overflow: auto;
  padding-bottom:198px;

  .card-wrap {
    margin-top: 24px;

    .day-plan-card {
      background: $bgColor;
      padding: 0px 24px;

      .collapse-title {
        display: flex;
        align-items: center;

        .tag {
          // width: 68px;
          height: 30px;
          margin-right: 7px;
          padding: 0 2px;
          font-size: 20px;
          font-weight: 400;
          line-height: 28px;
          text-align: center;
          color: rgba(225, 32, 32, 1);
          opacity: 1;
          background: rgba(255, 255, 255, 1);
          border: 2px solid rgba(225, 32, 32, 1);
          border-radius: 4px;
        }

        .title-left {
          width: 342px;
          display: flex;
          justify-content: start;
          align-items: center;
        }

        .title-right {
          width: 342px;
          margin-left: 18px;
          display: flex;
          justify-content: start;
          align-items: center;
        }
      }

      .content {
        .content-line {
          display: flex;
          align-items: center;

          .content-line-label {
            width: 40%;
            text-align: right;
          }

          .content-line-value {
            width: 60%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0 16px;

            // color: #666666;
            .content-line-field {
              height: 64px;
              border: 1PX solid #666666;
              border-radius: 10px;
              padding: 0.1rem 0.16rem;
            }

            .icon-edit {
              width: 27.21px;
              height: 32px;
            }
          }

          .font-red {
            color: #E12020;
          }
        }
      }
    }
  }
}

.icon-calendar {
  width: 42px;
  height: 37.26px;
}

.icon-select-arrow {
  width: 20px;
  height: 10px;
}

.icon-arrow-down {
  width: 20px;
  height: 10px;
  position: absolute;
  right: 19px;
}

.mar-l-18 {
  margin-left: 18px;
}
</style>